//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return { team: {}, sentences: [], words: [], comments: [], isMyTurn: false, contest: null, comment: '' }
  },
  computed: {
    deadlineText () {
      const d = this.team.currentTurnDeadline || this.team.current_turn_deadline
      if (!d) return ''
      return typeof d === 'string' ? d.replace('T', ' ').slice(0, 19) : String(d)
    }
  },
  created () { this.load() },
  methods: {
    load () {
      this.$ajax.get(this.$api.slTeamDetail + '?id=' + this.$route.query.id).then(r => {
        this.team = r.team || {}
        this.sentences = r.sentences || []
        this.words = r.words || []
        this.comments = r.comments || []
        this.isMyTurn = !!r.is_my_turn
        this.contest = r.contest
      })
    },
    goWrite () {
      this.$router.push({ path: '/slWrite_display', query: { id: this.team.id } })
    },
    collect (s) {
      this.$ajax.post(this.$api.slSentenceCollect, { sentence_id: s.id }).then(() => {
        this.$toast && this.$toast('已收藏')
      }).catch(e => { this.$toast && this.$toast(e.message || '收藏失败') })
    },
    vote () {
      this.$ajax.post(this.$api.slVote, {
        contest_id: this.contest && this.contest.id,
        team_id: this.team.id
      }).then(() => {
        this.$toast && this.$toast('投票成功')
      }).catch(e => { this.$toast && this.$toast(e.message || '投票失败') })
    },
    sendComment () {
      const content = (this.comment || '').trim()
      if (!content) return
      this.$ajax.post(this.$api.slComment, {
        contest_id: this.contest && this.contest.id,
        team_id: this.team.id,
        content
      }).then(() => {
        this.comment = ''
        this.$toast && this.$toast('已发送')
        this.load()
      }).catch(e => { this.$toast && this.$toast(e.message || '发送失败') })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/innovation/story-ladder/team-room.vue